import Main from "./main"
import Sidebar from "./sidebar"

export default {Main, Sidebar}
